(function ($) {
    $('.cc_cat_hover').hide();
    $(document).gp_ready(function() {
        $('.cc_cat').each(function(){
            const $this = $(this);
            $this.mouseenter(function() {
                $this.find($('.cc_cat_hover')).stop(true, true).slideDown(200);
            });

            $this.mouseleave(function() {
                $this.find($('.cc_cat_hover')).stop(true, true).slideUp(200);
            });
        })
    });
})(jQuery);
